// The Agent sidebar's session list model, in one of three states:
//
// - "loading": the list has not arrived. Skeleton rows stand in and New
//   stays dark, so the real list lands without a flash.
// - "empty": the user has no sessions. New lights up as the only row.
// - "sessions": the list. An empty current chat is the "New" row, not a
//   listed session: the row lights up and the chat is left out of the
//   list. A saved chat whose history is still loading has no messages yet
//   either, but it is not new, so it stays listed and selected until the
//   history lands (otherwise the New row blinks on each click).
//
// Pure, so the rules have tests.

export type SessionListState = "loading" | "empty" | "sessions";

export function sessionList<T extends { id: string }>({
  conversations,
  currentId,
  messagesLoaded,
  messageCount,
  loading = false,
}: {
  conversations: T[];
  currentId: string | null;
  /** The current chat's messages are known (fresh, or fetched). */
  messagesLoaded: boolean;
  messageCount: number;
  /** The session list itself is still on its way. */
  loading?: boolean;
}): { state: SessionListState; listed: T[]; newActive: boolean } {
  if (loading) return { state: "loading", listed: [], newActive: false };
  if (conversations.length === 0) {
    return { state: "empty", listed: [], newActive: true };
  }
  const currentIsEmpty =
    currentId != null && messagesLoaded && messageCount === 0;
  return {
    state: "sessions",
    listed: currentIsEmpty
      ? conversations.filter((c) => c.id !== currentId)
      : conversations,
    newActive: currentIsEmpty,
  };
}
